export default __webpack_public_path__ + "static/logo_main_white-afa7937af48dfd86a613e7d0c57e29ab.png";